import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { HisOptionXtd } from '../../../../core/model/his-option';

@Component( {
    selector: 'his-multiselect-selected-options-list',
    templateUrl: './his-multiselect-selected-options-list.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
} )
export class HisMultiselectSelectedOptionsListComponent {
    readonly hisDdKey = input<string | undefined>( undefined );
    /** Disables all ui elements  */
    readonly disabled = input( false, { transform: booleanAttribute } );

    /** Alternative property to use as the text for the displayed labels. */
    readonly field = input<string | undefined>( undefined );
    /** The max number of labels to be displayed. Options that exceed the limit are hidden behind an expandable overflow label. */
    readonly maxDisplayedSelections = input<number>( 10 );
    /** Controls the open/close state of the overflow label, if present. */
    readonly showAllSelectedOptions = model<boolean>( false );

    /** The options which were previously selected already. */
    readonly selectedOptions = input<HisOptionXtd[]>( [] );
    readonly selectedOptionsChange = output<HisOptionXtd[]>();

    protected readonly hasSelectedOptions = computed( () => this.selectedOptions().length > 0 );

    protected toggleShowAll() {
        this.showAllSelectedOptions.update( v => !v );
    }

    protected labelFor( option: HisOptionXtd ) {
        return option[this.field() ?? ''] || option.label;
    }

    protected removeOption( index: number ) {
        const newSelection = [...this.selectedOptions()];
        newSelection.splice( index, 1 );
        if ( newSelection.length <= this.maxDisplayedSelections() && this.showAllSelectedOptions() ) {
            // if options dont exceed the limit, reset the overflow lable to be shown again
            this.showAllSelectedOptions.set( false );
        }
        this.selectedOptionsChange.emit( newSelection );

    }
}
